import { QueryObserverResult, RefetchOptions } from '@tanstack/react-query';

import { Partner } from '@/configs/partner';
import { usePartnerData } from '@/queries/Partners';
import { useProducts } from '@/queries/Products';
import { Product } from '@/queries/types/graphql';

export interface PartnerProductsData {
  isLoading: boolean;
  isError: boolean;
  data: Product[];
  refetch: (
    options?: RefetchOptions,
  ) => Promise<QueryObserverResult<Product[], Error>>;
}

const usePartnerProducts = (partner: Partner): PartnerProductsData => {
  // Fetch productSelections for partner
  const {
    data: partnerData,
    isLoading: partnerDataLoading,
    isError: partnerDataError,
  } = usePartnerData(partner);

  const {
    data: productData,
    isLoading: productDataLoading,
    isError: productDataError,
    refetch: refetchProducts,
  } = useProducts({ productType: 'Ring' });

  const productOptions = partnerData?.productSelections;

  // For business.ouraring.com, return all product data
  if (partner === Partner.business) {
    return {
      isLoading: partnerDataLoading || productDataLoading,
      isError: productDataError || partnerDataError,
      data: productData ?? [],
      refetch: refetchProducts,
    };
  }

  return {
    isLoading: partnerDataLoading || productDataLoading,
    isError: productDataError || partnerDataError,
    data:
      productData?.filter((product) => productOptions?.includes(product.id)) ??
      [],
    refetch: refetchProducts,
  };
};

export default usePartnerProducts;
